var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ak-form-decorator",
    {
      attrs: {
        id: _vm.id,
        title: _vm.title,
        helpText: _vm.helpText,
        error: _vm.error,
        hasError: _vm.hasError,
        required: _vm.required,
        value: _vm.value,
      },
    },
    [
      _c("span", { staticClass: "ak-form__prefix" }, [
        _vm._v("\n        " + _vm._s(_vm.prefix) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "vue-autonumeric",
        _vm._g(
          {
            staticClass: "ak-form__control ak-form__control--prefix",
            class: {
              "ak-form__control--has-value": _vm.currentValue,
            },
            attrs: {
              options: _vm.autoNumericOptions,
              placeholder: _vm.placeholder,
              readonly: _vm.readOnly,
            },
            model: {
              value: _vm.currentValue,
              callback: function ($$v) {
                _vm.currentValue = $$v
              },
              expression: "currentValue",
            },
          },
          _vm.$currentListeners
        )
      ),
      _vm._v(" "),
      _vm._t("popover"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }